import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import MainPage from './pages/MainPage';
import { ProvideFirebase } from './hooks/firebase';
import { ProvideToast } from './hooks/use-toast';
import './i18n';
import './assets/fonts/OpenSans-Regular.ttf';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { ProvideFreshchat } from './hooks/freshchat';
import { ProvideUser } from './hooks/use-user';

function App() {
	return (
		<ProvideFirebase>
			<Router>
				<ProvideUser>
					<ErrorBoundary>
						<ProvideToast>
							<ProvideFreshchat>
								<MainPage />
							</ProvideFreshchat>
						</ProvideToast>
					</ErrorBoundary>
				</ProvideUser>
			</Router>
		</ProvideFirebase>
	);
}

export default App;
